//------------- COMPONENT BUTTONS HOME ---------

//botões utilizados na página home

//aqui será necessário alterar o url redirecionado dos botões:
// - planos de ação
//quando estas páginas forem finalizadas
//por enquanto, estão enviando ao Login

//apague esses comentarios quando terminar as tarefas kkkkkk

//importações
import React from "react";
import "./styles.css";
import { Link } from "react-router-dom";

//icons
import { FaRoute } from "react-icons/fa";
import { BsCalendarWeek, BsMap, BsFillCalendarCheckFill } from "react-icons/bs";
import { FaRegClipboard } from "react-icons/fa";
import { faHelmetSafety } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//aqui são personalizaveis a cor, o texto, o titulo e o icone do botão
const ButtonMenu = ({ bgColor, text, icon, title }) => {
    //importe o icone desejado e adicione ele aqui
    const handleIcon = () => {
        switch (icon) {
            case "rotas":
                return <FaRoute className="btn-menu-icon"></FaRoute>;
            case "agenda":
                return <BsCalendarWeek className="btn-menu-icon"></BsCalendarWeek>;
            case "mapa":
                return <BsMap className="btn-menu-icon"></BsMap>;
            case "tecnicos":
                return <FontAwesomeIcon icon={faHelmetSafety} className="btn-menu-icon" />;
            case "realizados":
                return <BsFillCalendarCheckFill className="btn-menu-icon"></BsFillCalendarCheckFill>

            default:
                break;
        }
    };

    //adicione a rota de navegação que pretende redirecionar
    const handleLink = () => {
        switch (icon) {
            case "rotas":
                return "/agenda/rotas";
            case "agenda":
                return "/agenda";
            case "mapa":
                return "/mapa";
            case "tecnicos":
                return "/agenda/tecnicos";
            case "realizados":
                return "/realizados"

            default:
                break;
        }
    };

    //retorna o component já com o link
    return (
        <div className="div-btn-menu" style={{ backgroundColor: bgColor }}>
            <Link id="button-menu" to={handleLink()}>
                {handleIcon()}
                <p className="title">{title}</p>
                <p className="text">{text}</p>
            </Link>
        </div>
    );
};

export default ButtonMenu;
